import { Component, OnInit } from '@angular/core';
import { DateHelper } from '../../helpers/DateHelper';
import { ITripSearchResult } from '../../models/trips/trip';
import { DailyTripService } from '../../services/daily-trip.service';
import { TripService } from '../../services/trip.service';
import { sortBy } from 'lodash';
import { ETripType } from '../../enums/trip-type';
import { Router } from '@angular/router';
import { APP_ROUTES } from '../../contants/APP_ROUTES';
import { QUERY_PARAMS } from '../../contants/QUERY_PARAMS';

interface ITableEntry {
	tripId: number;
	billOfLading: string;
	clientId: number;
	client: string;
	shippingLine: string;
	tripTypeId: number;
	
	containerId: number;
	containerNumber: string;
	containerSize: string;
	containerPickupPoint: string;
	containerDestination: string;
	dailyTripId?: number;

	status: string;
}

@Component({
	selector: 'app-dashboard-bookkeeper',
	templateUrl: './dashboard-bookkeeper.component.html',
	styleUrls: ['./dashboard-bookkeeper.component.css']
})
export class DashboardBookkeeperComponent implements OnInit {
	
	plateNumbers: string[] = null;		
	entries = [
		{ label: "Import", data: [] },
		{ label: "Return Empty", data: [] },
		{ label: "Export", data: [] },
		{ label: "Domestic", data: [] }
	];
	isTripDataLoading = true;

	constructor(
		private _dailyTripService: DailyTripService,
		private _tripService: TripService,
		private _router: Router
	) { }

	ngOnInit() {		

		this._tripService.searchV2({
			pageNumber: 1,
			pageSize: 10000,
			pageTotal: 10000,
			searchFilter: {
				createdDateFrom: '2024/06/23' // HARD DATE BECAUSE OF NEW FEATURE 2024/06/23
			}
		}).subscribe(result => {
			result.data.forEach((trip: ITripSearchResult) => {
				trip.containers
					.filter(container => container.driverRate > 0)
					.forEach(container => {
						const entry: ITableEntry = {
							tripId: trip.id,
							billOfLading: trip.billOfLading,
							clientId: trip.clientId,
							client: trip.client,
							shippingLine: trip.shippingLine,
							tripTypeId: trip.tripTypeId,
							
							dailyTripId: container.dailyTripId,
							containerId: container.id,
							containerNumber: container.containerNumber,
							containerSize: container.containerSize,
							containerPickupPoint: container.pickupPoint,
							containerDestination: container.destination,
							status: "Pending"
						};

						if(container.containerNumberTwo){
							entry.containerNumber = `${container.containerNumber} / ${container.containerNumberTwo}`;
						}
						
						if((trip.tripTypeId !== ETripType.Import && container.hasDailyTripTicketId) || container.hasReturnEmptyDailyTripTicketId){
							return;
						}
						else if(container.dailyTripId > 0 || container.returnEmptyDailyTripId > 0){
							entry.status = "Encoded";
						}

						if (trip.tripTypeId === ETripType.Import) {
							if(container.hasDailyTripTicketId){								
								if(container.returnEmptyDailyTripId && container.returnEmptyDailyTripId > 0){
									entry.dailyTripId = container.returnEmptyDailyTripId;
								}
								else{
									entry.dailyTripId = undefined;
									entry.status = "Pending";
								}

								this.entries[1].data.push(entry);
							}							
							else {
								this.entries[0].data.push(entry);
							}							
						} else if (trip.tripTypeId === ETripType.Export) {
							this.entries[2].data.push(entry);
						} else if (trip.tripTypeId === ETripType.Domestic) {
							this.entries[3].data.push(entry);
						}
					});
			});			

			this.isTripDataLoading = false;
		});

		const weeklyPeriod = DateHelper.getWeeklyPeriod(new Date());
		this._dailyTripService.getDailyTripsList({
			pageNumber: 1,
			pageSize: 3000,
			pageTotal: 3000,
			searchFilter: {
    			tripDateFrom: weeklyPeriod.from,
				tripDateTo: weeklyPeriod.to
			}
		}).subscribe(result => {
			const plateNumbers = result.data
				.map(x => x.truck)
				.filter((value, index, array) => array.indexOf(value) === index);

			this.plateNumbers = plateNumbers.length > 0 ? sortBy(plateNumbers) : [];
		});
	}

	onPendingWorkRowClick(e: ITableEntry){
		if(e.dailyTripId > 0){
			this._router.navigate([APP_ROUTES.dailyTripForm.replace('/:id', ''), e.dailyTripId]);
		}
		else{
			this._router.navigate(
				[APP_ROUTES.dailyTripForm.replace('/:id', ''), 0]
				, { 
					queryParams: {  
						[QUERY_PARAMS.CLIENT_ID]: e.clientId, 
						[QUERY_PARAMS.TRIP_ID]: e.tripId, 
						[QUERY_PARAMS.CONTAINER_ID]: e.containerId 
					} 
				}
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard-bookkeeper/dashboard-bookkeeper.component.ts